module.exports = __webpack_public_path__ + "img/zc1.096333f3.png";